import React from 'react'

/** Eyedropper artwork for screen color pick — inlined so ColorPicker always shows the design-spec icon. */
export function ScreenColorPickIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="16"
      height="18"
      viewBox="0 0 16 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.2791 0.575163C13.0731 -0.19172 14.3605 -0.191722 15.1545 0.575162C15.9485 1.34205 15.9485 2.58541 15.1545 3.35229L13.4553 4.99335L14.6316 6.12942C14.8482 6.33857 14.8482 6.67767 14.6316 6.88682C14.4151 7.09597 14.064 7.09597 13.8474 6.88682L12.6711 5.75075L6.78963 11.4312C5.9956 12.1981 4.70823 12.1981 3.91421 11.4312C3.12018 10.6643 3.12018 9.42098 3.91421 8.65409L9.79572 2.97362L8.61938 1.83749C8.40283 1.62834 8.40283 1.28924 8.61938 1.08009C8.83594 0.870942 9.18704 0.870942 9.40359 1.08009L10.5799 2.21622L12.2791 0.575163ZM14.3703 2.59489L12.6711 4.23595L11.3641 2.97362L13.0633 1.33256C13.4242 0.983979 14.0094 0.983979 14.3703 1.33256C14.7312 1.68115 14.7312 2.24631 14.3703 2.59489ZM10.5799 3.73102L11.8869 4.99335L6.00542 10.6738C5.6445 11.0224 5.05933 11.0224 4.69841 10.6738C4.33749 10.3252 4.33749 9.76008 4.69841 9.41149L10.5799 3.73102Z"
        fill="#475161"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.60226 12.1329C2.49942 11.9839 2.32628 11.8944 2.14088 11.8944C1.95547 11.8944 1.78233 11.9839 1.67949 12.1329L0.36255 14.0407C-0.584344 15.4125 0.433838 17.25 2.14088 17.25C3.84791 17.25 4.86609 15.4125 3.9192 14.0407L2.60226 12.1329ZM1.28532 14.6349L2.14088 13.3954L2.99643 14.6349C3.45198 15.2949 2.96213 16.1789 2.14088 16.1789C1.31962 16.1789 0.82977 15.2949 1.28532 14.6349Z"
        fill="#475161"
      />
    </svg>
  )
}
